import { fetchPurchases } from 'apis/merchant-gateway/merchant-analytics/api';
import { AnalyticsFilter } from 'apis/merchant-gateway/merchant-analytics/types';
import useCursorPagination from 'common/hooks/useCursorPagination';

import { NUM_PURCHASES_PER_PAGE } from '../constants';

type FetchParams = {
  startDate: string;
  endDate: string;
  venueId: string;
  filters?: AnalyticsFilter[];
};

const usePurchases = (fetchParams: FetchParams) => {
  const enabled = !!fetchParams.startDate && !!fetchParams.venueId;

  return useCursorPagination(
    `/merchant-analytics-api/v2/venues/${fetchParams.venueId}/purchases`,
    {
      ...fetchParams,
      limit: NUM_PURCHASES_PER_PAGE,
    },
    fetchPurchases,
    { enabled, refetchOnMount: false, refetchOnWindowFocus: false, retry: false },
  );
};

export default usePurchases;
